export const Emails = {
  CONTACT: "contact@meidly.com",
  NO_REPLY: "noreply@meidly.com",
};
